import React, {useContext, useEffect, useState} from "react";
import OrderCardGroup from "../../ui/card/OrderCardGroup";
import {ITEMS_PER_PAGE} from "../../../constants/Constants";
import {ORDER_TYPE_PENDING, useStoreExecutions} from "../../../store/useStoreExecutions";
import AuthContext from "../../../contexts/AuthContext";
import {useOrders} from "../../../hooks/executions/useOrders";
import {useShopperPrebook} from "../../../hooks/useShoppers";
import {useActionsButtons} from "../../../hooks/executions/useActionsButtons";
import ModalCustom from "../../ui/modal/ModalCustom";
import ShopperModals from "../../ui/modal/ShopperModals";

export const ExecutionsCards = () => {
    const {user} = useContext(AuthContext);
    const getExecutions = useStoreExecutions(state => state.getExecutions);
    const executions = useStoreExecutions(state => state.executions);
    const isLoading = useStoreExecutions(state => state.isLoading);
    const executionsInProgress = useStoreExecutions(state => state.executionsInProgress);
    const isError = useStoreExecutions(state => state.isError);
    const type = useStoreExecutions(state => state.type);
    const {
        actionButtons,
        showModalInformation,
        setShowModalInformation,
        modalSize,
        modalTitle,
        modalContent,
        buttons,
        handleCancellationModal
    } = useActionsButtons();

    // Permet de charger une première fois les données avec Zustand
    useEffect(() => {
        getExecutions(user, true);
    }, [type, user]);

    return (
        <>
            {type !== ORDER_TYPE_PENDING && executions && executions.length > 0 && (
                <OrderCardGroup
                    isLoading={isLoading}
                    isError={isError}
                    data={executions}
                    actionButtons={actionButtons}
                    max={ITEMS_PER_PAGE}
                    user={user}
                />
            )}
            {type === ORDER_TYPE_PENDING && executionsInProgress && executionsInProgress.length > 0 && (
                <OrderCardGroup
                    isLoading={isLoading}
                    isError={isError}
                    data={executionsInProgress}
                    actionButtons={actionButtons}
                    max={ITEMS_PER_PAGE}
                    user={user}
                />
            )}
            <ModalCustom
                show={showModalInformation}
                id={'executions-modal'}
                onHide={() => setShowModalInformation(false)}
                size={modalSize}
                title={modalTitle}
                titleClassname={!modalTitle && 'text-center mb-3'}
                header={false}
                bodyClassname={'text-left'}
                content={
                    <>
                        {modalContent}
                    </>
                }
                footer={true}
                buttonsFooter={[
                    ...buttons,
                    ...[
                        {
                            text: 'Fermer',
                        },
                    ]
                ]}
            />

            <ShopperModals
                handleCancellationModal={handleCancellationModal}
                executions={type === ORDER_TYPE_PENDING ? executionsInProgress : executions}
            />
        </>
    );
}
